/** MUI Select menus inside Dialog (z-index 1300) must render above the modal surface. */
export const catalogSelectMenuProps = {
  PaperProps: {
    sx: { zIndex: 1400 },
  },
} as const
